import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, map, catchError, of } from 'rxjs';
import { EnvironmentConfig } from 'src/app/core/enviroment-config';
import { TaggableResourcePickupRoute } from 'src/app/data/model/taggable-resource-pickup-route';
import { ContainerTypeApiService } from 'src/app/shared/api/services/container-type-api.service';
import { PortalGroupApiService } from 'src/app/shared/api/services/portal-group-api.service';
import { TaggableResourceApiService } from 'src/app/shared/api/services/taggable-resource-api.service';
import { TaggableResourcePickupRouteApiService } from 'src/app/shared/api/services/taggable-resource-pickup-route-api.service';
import { BaseEntityListService } from 'src/app/shared/base/base-entity-list.service';
import { TaggableResourceRouteDialogComponent } from '../components/taggable-resource-route-dialog/taggable-resource-route-dialog.component';
import { environment } from 'src/environments/environment.api';
import { UserTableVisualizationApiService } from 'src/app/shared/api/services/user-table-visualization-api.service';

@Injectable({
  providedIn: 'root'
})
export class TaggableResourceRouteListService extends BaseEntityListService<
  TaggableResourcePickupRoute,
  TaggableResourcePickupRouteApiService,
  UserTableVisualizationApiService
> {
  protected openDialog(dialogParams: { id: number | null }): Observable<boolean> {
    return this.dialog
      .open<TaggableResourceRouteDialogComponent, { id: number | null }, boolean>(
        TaggableResourceRouteDialogComponent,
        {
          ...this.defaultDialogOptions,
          data: dialogParams,
        }
      )
      .afterClosed()
      .pipe(map(result => result ?? false));
  }

  private getPath(path: string): string {
    return environment.apiUrl
      ? `${environment.apiUrl}/${path}`
      : `/${path}`;
  }

  checkIfOnRoad(lat: number, lon: number): Observable<boolean> {
    const url = this.getPath(`moda/osrm/${lon},${lat}/`);

    return this.http.get<any>(url, {headers: new HttpHeaders({"Content-Type": "application/json"})}).pipe(
      map(res => {
        const dist = res.waypoints?.[0]?.distance || 1000;
        return dist < 1; 
      }),
      catchError(() => of(false))
    );
  }
  get groups$() {
    return this.portalGroupService.getAll().pipe(map((res) => res.results));
  }
  get types$() {
    return this.resourceService.getAll().pipe(map((res) => res.results));
  }

  constructor(
    dialog: MatDialog,
    apiService: TaggableResourcePickupRouteApiService,
    columnService: UserTableVisualizationApiService,
    private portalGroupService: PortalGroupApiService,
    private resourceService: ContainerTypeApiService,
    private http: HttpClient
  ) {
    super(dialog, apiService, columnService);
  }
}
